import { Mail } from "lucide-react";
import type { PreviewResponse } from "../../types/preview";
import type { ReleasedDocument } from "../../types/api";
import { hasValidCnpj } from "../../lib/qualification";
import { VerifyTag } from "./VerifyTag";
import { CopyChannelsButton } from "./CopyChannelsButton";

export const hasNotificadaSummary = (_preview: PreviewResponse, released: ReleasedDocument | null): boolean => released === null;

const DT = "font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-500";

export function NotificadaSummary({ preview }: { preview: PreviewResponse }) {
  const d = preview.notificada;
  const rows: [string, string, string][] = [
    ["instituicao", preview.niche === "saldo-retido" ? "Instituição" : "Rede / Incorporadora", d.razaoSocial],
    ["cnpj", "CNPJ", hasValidCnpj(d.cnpj) ? d.cnpj : "CNPJ a confirmar"],
    ...(d.sede?.trim() ? [["sede", "Sede", d.sede.trim()] as [string, string, string]] : []),
  ];
  return (
    <section data-testid="notificada-summary" aria-label="Resumo da notificada" className="mx-auto mt-6 w-full max-w-[794px] rounded-sm bg-slate-50 p-6 text-slate-900 ring-1 ring-slate-300 sm:p-8">
      <p className="font-mono text-xs uppercase tracking-[0.16em] text-slate-500">Resumo antes do pagamento</p>
      <dl className="mt-4 grid gap-4 sm:grid-cols-3">
        {rows.map(([id, k, v]) => (
          <div key={id}>
            <dt className={DT}>{k}</dt>
            <dd data-testid={`notificada-summary-${id}`} className="mt-1 text-sm font-semibold">{v}</dd>
          </div>
        ))}
      </dl>
      {preview.emails.length > 0 && (
        <div className="mt-5 border-t border-slate-300 pt-4">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className={DT}>Canais de Notificação</p>
            <CopyChannelsButton emails={preview.emails} tone="light" />
          </div>
          <ul data-testid="notificada-summary-canais" className="mt-2 flex flex-wrap items-center gap-x-1 gap-y-2 font-sans text-xs text-slate-800">
            {preview.emails.map((e, i) => (
              <li key={e.email} data-testid={`notificada-summary-canal-${i}`} className="inline-flex items-center gap-1.5">
                <Mail aria-hidden="true" className="h-3.5 w-3.5 text-slate-500" />
                <span className="break-all font-mono">{e.email}</span>
                <VerifyTag ok={e.verificado} testId={`notificada-summary-canal-${i}-tag`} />
                {i < preview.emails.length - 1 && <span aria-hidden="true" className="-ml-1 mr-1.5">,</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
